module.exports = __webpack_public_path__ + "images/onboarding-banner/priming-for-aa.7847bb7ea76060aee5fa.png";